import {
  GET_USERS_START,
  GET_USERS_ERROR,
  GET_USERS_SUCCESS,
} from 'constants/action-types/user/getUsers';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_USERS_START:
      return {
        ...state,
        usersList: {
          ...state.login,
          message: null,
          loading: true,
          error: null,
        },
      };
    case GET_USERS_ERROR:
      return {
        ...state,
        usersList: {
          ...state.login,
          error: payload,
          loading: false,
          message: null,
        },
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        usersList: {
          items: payload.data ? payload.data : [],
          meta: payload.meta,
          loading: false,
          message: null,
        },
      };
    default:
      return null;
  }
};
